import Vue from "vue";
import "./plugins/fontawesome";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "@/plugins/vuetify";
import axios from "axios";
import hasAccess from "@/plugins/hasAccess";
import i18n from "@/plugins/i18n";
import "@/components/base/base";
import "@/components/zoyride/zoyride";
import "@/plugins/chartist";
import VueMoment from "vue-moment";
import * as VueGoogleMaps from "vue2-google-maps";
import ToggleButton from "vue-js-toggle-button";
import VueCookies from "vue-cookies";
import VueWindowSize from "vue-window-size";

Vue.config.productionTip = false;
Vue.prototype.$http = axios;
Vue.prototype.$ha = hasAccess;
Vue.use(ToggleButton);
Vue.use(VueWindowSize);

Vue.use(i18n, {
  store: new i18n.Store(),
});

Vue.use(VueMoment);
Vue.use(VueCookies);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBSmNnUXtSOkmZDbnegdWq7eV9-EXVrC-Q",
    libraries: "places", // necessary for places input
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
